import { CommonSettingsServiceType } from './interface';
import axiosInstance from '@/api';
import { CommonSettings, SaveSettingsParams } from '@/services/api/settingsApiArea/types';

/** Класс фабрика UserService который хранит в себе API методы для работы с группами **/
export class CommonSettingsService implements CommonSettingsServiceType {
  async GetSettings(): Promise<CommonSettings> {
    try {
      const res = await axiosInstance.get('v1/settings/common');
      return res.data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }

  async SaveSettings(params: SaveSettingsParams): Promise<CommonSettings> {
    try {
      const res = await axiosInstance.post('v1/settings/common', params);
      return res.data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }
}
